export default "__VITE_ASSET__qxY8T2Y7__"